import { useEffect, useState } from "react"
import { useCoralHeader } from "@octopus-energy/coral/organisms"
import { useDashboardMenu } from "@/features/navigation/hooks/useDashboardMenu"
import { AccountMenu } from "../AccountMenu"
import { NavigationMenuList } from "../NavigationMenuList"

function DashboardMenuMobile() {
    const [mounted, setMounted] = useState(false)
    useEffect(() => setMounted(true), [])

    const { isMenuOpen } = useCoralHeader()
    const dashboardMenu = useDashboardMenu()

    if (!isMenuOpen || !mounted) {
        return null
    }

    return (
        <>
            <NavigationMenuList items={dashboardMenu} />
            <AccountMenu.Mobile />
        </>
    )
}

export const DashboardMenu = {
    Mobile: DashboardMenuMobile,
    messages: [...AccountMenu.messages, ...useDashboardMenu.messages] as const,
}
